import { render, staticRenderFns } from "./group-management-table.vue?vue&type=template&id=56c47a47&scoped=true&"
import script from "./group-management-table.vue?vue&type=script&lang=js&"
export * from "./group-management-table.vue?vue&type=script&lang=js&"
import style0 from "./group-management-table.vue?vue&type=style&index=0&id=56c47a47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c47a47",
  null
  
)

export default component.exports